function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SintMaartenFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1296",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1296)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1296",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask1_621_1296)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 12V21H24V12H0Z",
        fill: "#2E42A5"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 1.5V22.5L15 12L0 1.5Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask2_621_1296",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "1",
      width: "15",
      height: "22",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.5V22.5L15 12L0 1.5Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask2_621_1296)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.09442 9.89161C7.17195 9.89161 8.04547 9.35623 8.04547 8.6958C8.04547 8.03538 7.17195 7.5 6.09442 7.5C5.01689 7.5 4.14337 8.03538 4.14337 8.6958C4.14337 9.35623 5.01689 9.89161 6.09442 9.89161Z",
        fill: "#FBCD17"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.26509 7.789C6.10581 7.789 5.99264 7.89161 5.99264 8.04606L5.99278 8.0631C5.98423 8.08884 5.97943 8.11752 5.97856 8.14963C5.97635 8.2318 6.00695 8.30034 6.07117 8.36321C6.07512 8.38135 6.07717 8.39639 6.07659 8.40492C6.07269 8.39152 6.05719 8.38028 6.02767 8.35888C5.98571 8.32846 5.91542 8.2775 5.80986 8.17058C5.65782 8.01658 5.54309 7.9563 5.40046 7.98025C5.35722 7.98751 5.3149 8.00275 5.26408 8.0231C5.18306 8.05227 5.10848 8.05905 4.97078 8.03276C4.58812 7.95972 4.16842 8.03139 3.71405 8.24194L3.87172 8.58218C4.2595 8.40249 4.60162 8.34407 4.90047 8.40111C5.10576 8.4403 5.2483 8.42735 5.39113 8.37592C5.45268 8.35277 5.45806 8.35083 5.46257 8.35007C5.45804 8.35083 5.46095 8.35362 5.47997 8.3719C5.49278 8.38421 5.5129 8.40355 5.543 8.43403C5.58586 8.47745 5.63066 8.51675 5.67643 8.5525C5.58847 8.57613 5.59302 8.59236 5.60916 8.64993C5.61574 8.67338 5.62424 8.70371 5.62919 8.74419C5.64013 8.83357 5.62196 8.87966 5.63764 8.90174C5.65512 8.92636 5.71472 8.92109 5.90385 8.91266C5.95475 8.91039 6.0236 8.90514 6.10304 8.89762C6.25883 8.88289 6.43515 8.86141 6.54349 8.84365C6.64874 8.8264 6.67671 8.82011 6.72085 8.78798L6.72086 8.78797C6.73612 8.76926 6.74917 8.75325 6.75999 8.73899C7.11986 8.68612 7.43986 8.64855 7.72462 8.62264C7.82671 8.61335 7.90876 8.60698 7.98821 8.60115C7.9976 8.60106 7.9976 8.60106 8.04376 8.59141L8.04377 8.5914C8.06395 8.58282 8.0723 8.57928 8.07512 8.57809L8.07509 8.57817C8.07636 8.5776 8.07711 8.57726 8.07512 8.57809L8.16703 8.36038L8.07207 8.24554C8.0155 8.22776 8.00925 8.2258 8.00292 8.22552C8.00214 8.22549 8.00135 8.22548 8.00047 8.22547C7.99304 8.22504 7.99034 8.22488 7.98764 8.22479C7.9861 8.22474 7.98455 8.22472 7.98212 8.22468C7.95203 8.22449 7.95203 8.22449 7.89614 8.22456H7.89612C7.83383 8.22456 7.78462 8.21929 7.71354 8.20665L7.64743 8.1945C7.35508 8.14087 7.08392 8.14087 6.50883 8.22661C6.49799 8.21823 6.48722 8.20996 6.47669 8.20206C6.56931 8.18596 6.6821 8.17504 6.8013 8.16868L6.80131 8.16868C6.87336 8.16533 6.87337 8.16533 6.9136 8.16425L6.9312 8.16384L6.929 7.78903L6.90055 7.789H6.26509ZM5.95445 8.87463L5.99031 8.86718L6.02563 8.85964C6.01916 8.86101 6.01199 8.86251 6.00405 8.86416C5.99 8.8671 5.97356 8.87052 5.95445 8.87463Z",
        fill: "#DA610A"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.96398 9.31217L6.00443 9.06547L6.04487 9.31217C6.79414 9.18933 7.30988 9.19906 7.62417 9.30448C7.97637 9.42261 8.38449 9.36193 8.83039 9.17256C8.6754 9.78892 8.59647 10.3647 8.59647 10.8989C8.59647 11.4275 8.69846 11.8551 8.79394 12.2406C8.79696 12.2528 8.79997 12.265 8.80297 12.2771C8.89573 12.6512 8.97675 12.978 8.97675 13.3533C8.97675 13.7097 8.85538 13.9206 8.66713 14.0539C8.46312 14.1983 8.14346 14.2778 7.70368 14.2778C7.09622 14.2778 6.52961 14.4486 6.00827 14.7847L6.00443 14.7819L6.00058 14.7847C5.47925 14.4486 4.91263 14.2778 4.30518 14.2778C3.8654 14.2778 3.54573 14.1983 3.34172 14.0539C3.15347 13.9206 3.0321 13.7097 3.0321 13.3533C3.0321 12.978 3.11312 12.6512 3.20588 12.2771C3.20888 12.265 3.21189 12.2528 3.21491 12.2406C3.31039 11.8551 3.41238 11.4275 3.41238 10.8989C3.41238 10.3647 3.33345 9.78892 3.17846 9.17256C3.62437 9.36193 4.03248 9.42261 4.38468 9.30448C4.69897 9.19906 5.21471 9.18933 5.96398 9.31217Z",
        fill: "#56C6F5",
        stroke: "#E31D1C",
        strokeWidth: "0.5"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.58862 10.6682L6.01005 10.1539L5.43148 10.6682H5.60293V10.9646L4.70291 11.5253V12.8967H4.53149V13.1539H7.53149V12.8967H7.31719V11.5253L6.37436 10.938V10.6682H6.58862Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.96393 15.7653C6.75971 15.7653 7.30755 15.6784 7.58965 15.5303C7.66361 15.4046 7.79331 15.3336 7.93133 15.3387C8.55117 15.3616 9.03123 15.1005 9.40862 14.5266C9.81638 13.9065 9.89832 13.0256 9.63255 11.8694L10.3073 11.7143C10.6118 13.0391 10.5123 14.1082 9.98707 14.9069C9.51639 15.6227 8.87464 16.005 8.09144 16.031C7.69143 16.3272 6.99042 16.4576 5.96393 16.4576C4.97089 16.4576 4.2346 16.2648 3.76238 15.8551C2.68997 15.6018 2.00847 15.174 1.7405 14.54C1.45485 13.8642 1.45485 12.9259 1.72131 11.7173L2.39738 11.8664C2.15897 12.9478 2.15897 13.7518 2.37819 14.2705C2.53117 14.6324 2.97565 14.9278 3.72867 15.1326L4.42828 15.2822L4.3947 15.4588C4.736 15.6583 5.25761 15.7653 5.96393 15.7653Z",
        fill: "#FBCD17"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3.53552 9.61795L3.91904 9.77224L3.72728 10.1709L4.26367 9.89442L4.222 10.0991L4.10701 10.664L4.32678 10.0207V10.589L4.46106 10.0207L4.85983 10.141L4.46106 9.89442L4.85983 9.77224",
        stroke: "#73BE4A",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.26666 10.4528C4.47377 10.4528 4.64166 10.2849 4.64166 10.0778C4.64166 9.87068 4.47377 9.70279 4.26666 9.70279C4.05956 9.70279 3.89166 9.87068 3.89166 10.0778C3.89166 10.2849 4.05956 10.4528 4.26666 10.4528Z",
        fill: "#FBCD17"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.98082 10.405C7.97468 10.1528 7.94665 9.57693 7.8187 9.57693C7.68999 9.57693 7.67041 10.1595 7.66793 10.4094C7.44635 10.4818 7.27954 10.6725 7.27954 10.6725H8.3832C8.3832 10.6725 8.20933 10.4737 7.98082 10.405Z",
        fill: "#F7FCFF"
      })]
    })]
  })]
}));
//# sourceMappingURL=SintMaarten.js.map